let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Jbnf")).then(() => parcelRequire('avxN6'));